import {
  BanIcon,
  BanknoteIcon,
  CheckCircle2Icon,
  ClipboardListIcon,
  PackageIcon,
  PlayIcon,
  WrenchIcon,
  type LucideIcon,
} from "lucide-react";
import type { WorkshopJobStatusDTO } from "../../domain/contracts";

export const WORKSHOP_STATUS_ICONS: Record<WorkshopJobStatusDTO, LucideIcon> =
  {
    received: ClipboardListIcon,
    in_progress: WrenchIcon,
    waiting_parts: PackageIcon,
    completed: CheckCircle2Icon,
    paid: BanknoteIcon,
    cancelled: BanIcon,
  };

export function workshopStatusActionIcon(
  to: WorkshopJobStatusDTO,
  from?: WorkshopJobStatusDTO,
): LucideIcon {
  if (from === "waiting_parts" && to === "in_progress") {
    return PlayIcon;
  }
  return WORKSHOP_STATUS_ICONS[to];
}

export function workshopStatusPrimaryButtonClass(
  to: WorkshopJobStatusDTO,
): string {
  switch (to) {
    case "in_progress":
      return "border-amber-700 bg-amber-600 text-white shadow-sm shadow-amber-900/15 hover:bg-amber-700 dark:border-amber-500/45 dark:bg-amber-600 dark:hover:bg-amber-500";
    case "waiting_parts":
      return "border-orange-700 bg-orange-600 text-white shadow-sm shadow-orange-900/15 hover:bg-orange-700 dark:border-orange-500/45 dark:bg-orange-600 dark:hover:bg-orange-500";
    case "completed":
      return "border-emerald-700 bg-emerald-600 text-white shadow-sm shadow-emerald-900/15 hover:bg-emerald-700 dark:border-emerald-400/45 dark:bg-emerald-600 dark:shadow-emerald-950/40 dark:hover:bg-emerald-500";
    case "paid":
      return "border-emerald-800 bg-emerald-700 text-white shadow-sm hover:bg-emerald-800 dark:border-emerald-400/45 dark:bg-emerald-600 dark:hover:bg-emerald-500";
    default:
      return "";
  }
}

export function workshopStatusSecondaryButtonClass(
  status: WorkshopJobStatusDTO,
): string {
  switch (status) {
    case "waiting_parts":
      return "border-orange-200 bg-orange-50/50 text-orange-950 hover:bg-orange-100 dark:border-orange-500/35 dark:bg-orange-500/10 dark:text-orange-100 dark:hover:bg-orange-500/20";
    case "in_progress":
      return "border-amber-200 bg-amber-50/50 text-amber-950 hover:bg-amber-100 dark:border-amber-500/35 dark:bg-amber-500/10 dark:text-amber-100 dark:hover:bg-amber-500/20";
    case "completed":
      return "border-emerald-200 bg-emerald-50/50 text-emerald-950 hover:bg-emerald-100 dark:border-emerald-500/35 dark:bg-emerald-500/10 dark:text-emerald-100 dark:hover:bg-emerald-500/20";
    default:
      return "";
  }
}
